// 导入请求公用方法
import fetch from '@/utils/fetch'

// 首页加载产品服务列表
export const getServiceList = (params) => {
        return fetch({
            url: '/por-basis/por/basis/portal/demadProduct/queryList',
            method: 'get',
            params
        })
    }
    // 产品明细
export const getServiceDetail = (params) => {
        return fetch({
            url: '/por-basis/por/basis/portal/demadProduct/getDetailByCode',
            method: 'get',
            params
        })
    }
    // 服务商信息
export const serviceComponyDetail = (params) => {
        return fetch({
            url: '/por-user/api/por/pUserCertificates/getCorpDetailByCompanyId',
            method: 'get',
            params
        })
    }
    // 新增产品
export const addService = (data) => {
        return fetch({
            url: '/por-basis/por/basis/portal/demadProduct/auth/addProduct',
            method: 'post',
            data
        })
    }
    // 产品列表更多
export const ServiceList = (params) => {
    return fetch({
        url: '/por-basis/por/basis/portal/demadProduct/queryList',
        method: 'get',
        params
    })
}